import { ShieldCheck, Eye, GraduationCap, SlidersHorizontal, Lock } from "lucide-react";
import { FadeUp, Eyebrow, SectionShell } from "./Reveal";
import { WHY_US } from "../constants/site";

const ICONS = [ShieldCheck, Eye, GraduationCap, SlidersHorizontal, Lock];

export default function WhyUs() {
  return (
    <SectionShell id="why" className="py-24 sm:py-32">
      <div className="max-w-2xl">
        <FadeUp>
          <Eyebrow>Why partner with us</Eyebrow>
          <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.08] text-ink">
            Built for CPA firms who <span className="text-gradient">guard their name.</span>
          </h2>
        </FadeUp>
      </div>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {WHY_US.map((w, i) => {
          const Icon = ICONS[i % ICONS.length];
          const featured = i === 0;
          return (
            <FadeUp
              key={w.title}
              delay={i * 0.07}
              className={featured ? "sm:col-span-2 lg:col-span-1" : ""}
            >
              <div
                data-testid={`why-card-${i + 1}`}
                className={`group h-full rounded-3xl border p-7 transition-all duration-500 hover:-translate-y-1 ${
                  featured
                    ? "border-torange/40 bg-gradient-to-b from-torange/10 to-card shadow-lift"
                    : "border-line bg-card shadow-soft hover:border-bluze/40 hover:shadow-lift"
                }`}
              >
                <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-line bg-paper">
                  <Icon size={22} className={featured ? "text-torange" : "text-bluze"} />
                </div>
                <div className="flex items-baseline gap-3">
                  <span className="font-mono text-xs text-slate-300">0{i + 1}</span>
                  <h3 className="font-display text-lg sm:text-xl font-bold text-ink">{w.title}</h3>
                </div>
                <p className="mt-3 text-sm text-slate-500 leading-relaxed">{w.desc}</p>
              </div>
            </FadeUp>
          );
        })}

        <FadeUp delay={0.35} className="sm:col-span-2 lg:col-span-2">
          <div className="relative h-full overflow-hidden rounded-3xl border border-line bg-gradient-to-r from-bluedark/10 via-card to-torange/10 shadow-soft p-7 sm:p-10">
            <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-bluze/10 blur-3xl" />
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-torange font-bold">The operating principle</p>
            <p className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold leading-snug text-ink">
              "Transforming complexity <span className="text-gradient">into clarity</span> — for every client, every filing, every deadline."
            </p>
            <p className="mt-4 text-sm text-slate-500">— TaccTax Solution Pvt. Ltd.</p>
          </div>
        </FadeUp>
      </div>
    </SectionShell>
  );
}
